import { useEditor } from "@tiptap/react";
import { Document } from "@tiptap/extension-document";
import { Paragraph } from "@tiptap/extension-paragraph";
import { Text as TiptapText } from "@tiptap/extension-text";
import Bold from "@tiptap/extension-bold";
import { Italic } from "@tiptap/extension-italic";
import Underline from "@tiptap/extension-underline";
import { RichTextEditor } from "@mantine/tiptap";
import { Box } from "@mantine/core";
import classes from "./registrations.module.css";
import { useEffect } from "react";

const CustomTextDisplay = ({ content }) => {
  const editor = useEditor({
    extensions: [Document, Paragraph, TiptapText, Bold, Italic, Underline],
    content,
    editable: false,
  });

  useEffect(() => {
    if (editor && content) {
      editor.commands.setContent(content);
    }
  }, [content, editor]);

  if (!editor) return null;

  return (
    <Box px="xl" pt="xl">
      <RichTextEditor
        editor={editor}
        className={classes.customText}
        styles={{
          root: { border: "none", backgroundColor: "transparent" },
          content: { backgroundColor: "transparent" },
        }}
      >
        <RichTextEditor.Content />
      </RichTextEditor>
    </Box>
  );
};

export default CustomTextDisplay;
